export enum ProjectEventTypeStaticContent {
  CourseUnit,
}
